import {
  Typography as MUITypography,
  TypographyProps,
  styled,
} from "@mui/material";

export interface ITypography extends TypographyProps {
  type?: "h1" | "h2" | "h3" | "h4" | "h5" | "s1" | "s2" | "s3" | "s4" | "s5";
  weight?: "normal" | "medium" | "bold";
}

const StyledTypography = styled(MUITypography)<ITypography>(
  ({ theme: { palette }, color }) => ({
    color: color || palette.theme?.primary[800],
  }),
);

export function Typography(props: ITypography) {
  const {
    children,
    type = "h5",
    weight = "normal",
    className,
    ...rest
  } = props;

  return (
    <StyledTypography className={`${type} ${weight} ${className}`} {...rest}>
      {children}
    </StyledTypography>
  );
}

export default Typography;
